import axios from 'axios';

import localSvgIcons from '../../localSvgIcons.json';

const iconsCache = {};

const getIconFullName = (iconName) => `icon-${iconName}.svg`;

const hasIcon = (iconName) => localSvgIcons[getIconFullName(iconName)];

const getIcon = async (iconName) => {
	if (!hasIcon(iconName)) {
		throw new Error(`Icon ${iconName} not found`);
	}
	const iconFromCache = iconsCache[iconName];
	if (iconFromCache) {
		return iconFromCache;
	}
	const { data: icon } = await axios.get(`/assets/svg/${getIconFullName(iconName)}`);
	iconsCache[iconName] = icon;
	return icon;
};

const getExternalIconUrl = (iconName) => `${process.env.VUE_APP_PLY_BACKEND_ASSETS_URL}icons/${iconName}.svg`;

const IconService = { hasIcon, getIcon, getExternalIconUrl };

export default IconService;
